import { render, staticRenderFns } from "./InputLabel.vue?vue&type=template&id=2f917766&scoped=true&"
var script = {}
import style0 from "./InputLabel.vue?vue&type=style&index=0&id=2f917766&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f917766",
  null
  
)

export default component.exports